import React, {useState} from 'react';
import {Box, Button, Chip, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography} from '@mui/material';
import {DeleteOutline, LanguageOutlined, LockOutlined, StarOutline} from '@mui/icons-material';
import AlertDialog from '../../alert/AlertDialog';
import {settingsTableStyles} from '../SettingsDesign';

export default function DomainList({data = [], kind, remove, setDefault, disabled}) {
    const [deleteDomain, setDeleteDomain] = useState(null);
    const confirmDelete = confirm => {
        if (confirm) remove(deleteDomain.id);
        setDeleteDomain(null);
    };

    return <>
        <TableContainer>
            <Table size="small" sx={{...settingsTableStyles, minWidth: {xs: 0, sm: 560}}} aria-label={`${kind} domains`}>
                <TableHead>
                    <TableRow>
                        {['Domain', 'Type', 'Actions'].map(label => <TableCell key={label} align={label === 'Actions' ? 'right' : 'left'}
                            sx={{color: 'text.secondary', fontSize: 12, fontWeight: 600, py: 1.5, borderLeft: 0, borderColor: 'divider',
                                display: label === 'Type' ? {xs: 'none', sm: 'table-cell'} : 'table-cell'}}>{label}</TableCell>)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map(item => <TableRow key={item.id} sx={{'&:last-child td': {borderBottom: 0}}}>
                        <TableCell sx={{borderColor: 'divider'}}>
                            <Box sx={{display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap'}}>
                                <LockOutlined sx={{fontSize: 16, color: 'text.secondary'}}/>
                                <Typography sx={{fontSize: {xs: 13, sm: 14}, whiteSpace: 'normal', overflowWrap: 'anywhere'}}>https://{item.domain}</Typography>
                                {item.isDefault && <Chip label="Default" size="small" color="primary" variant="outlined" sx={{height: 23, fontSize: 11, borderRadius: '6px'}}/>}
                            </Box>
                            <Typography sx={{display: {xs: 'block', sm: 'none'}, mt: 0.5, color: 'text.secondary', fontSize: 12}}>{item.custom ? 'Custom domain' : 'Shared domain'}</Typography>
                        </TableCell>
                        <TableCell sx={{borderColor: 'divider', color: 'text.secondary', fontSize: 13, display: {xs: 'none', sm: 'table-cell'}}}>{item.custom ? 'Custom' : 'Shared'}</TableCell>
                        <TableCell align="right" sx={{borderColor: 'divider', whiteSpace: 'nowrap'}}>
                            {setDefault && !item.isDefault && <Tooltip title="Set as default"><span><Button size="small" aria-label={`Set ${item.domain} as default`}
                                onClick={() => setDefault(item)} disabled={disabled} sx={{borderRadius: '8px', minWidth: {xs: 32, sm: 64}, height: 30, py: 0, px: 1}}>
                                <StarOutline sx={{display: {xs: 'inline-flex', sm: 'none'}, fontSize: 20}}/>
                                <Box component="span" sx={{display: {xs: 'none', sm: 'inline'}}}>Set as default</Box>
                            </Button></span></Tooltip>}
                            {item.custom && <Tooltip title="Delete domain"><span><IconButton size="small" aria-label={`Delete ${item.domain}`} disabled={disabled}
                                onClick={() => setDeleteDomain(item)}><DeleteOutline sx={{fontSize: 20}} color="error"/></IconButton></span></Tooltip>}
                            {!item.custom && (!setDefault || item.isDefault) && <Typography sx={{fontSize: 12, color: 'text.secondary'}}>Included</Typography>}
                        </TableCell>
                    </TableRow>)}
                    {data.length === 0 && <TableRow><TableCell colSpan={3} sx={{borderBottom: 0, textAlign: 'center', py: 5}}>
                        <LanguageOutlined sx={{fontSize: 32, color: 'text.secondary', mb: 1}}/>
                        <Typography sx={{fontWeight: 600, fontSize: 14}}>No {kind} domains yet</Typography>
                        <Typography sx={{color: 'text.secondary', fontSize: 13, mt: 0.5}}>Add a domain to get started.</Typography>
                    </TableCell></TableRow>}
                </TableBody>
            </Table>
        </TableContainer>
        {deleteDomain && <AlertDialog question="Delete domain?" buttonColor="error"
            text={`Are you sure you want to delete the ${kind} domain ${deleteDomain.domain}?`} confirm={confirmDelete}/>}
    </>;
}
